<div class="w-100 position-absolute" [style.top.%]="top">  
	<span class="tr-button" [style.height.rem]="height"></span>
</div>